<svelte:options accessors/>
<script>
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import DocumentTable from "../../common/DocumentTable.svelte";
    import UbicacionTransporte from "./UbicacionTransporte.svelte";
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import UbicacionManejoVertical from "./UbicacionManejoVertical.svelte";
    import TipoEmbalaje from "./TipoEmbalaje.svelte";

    export let data = [];
    export let options = [];
    let document = [];

</script>
<div class="grid-5 gap-1 py-15">
    <div class="col-2">
        <NauiInput label="Correo" bind:value={data.datosCliente.email}/>
    </div>
    <NauiInput label="Teléfono" bind:value={data.datosCliente.telefono}/>
    <NauiSelect label="Tipo de documento" bind:value={data.datosCliente.tipoDoc} options="{options.tipo_documento}"/>
    <NauiInput label="Número de documento" bind:value={data.datosCliente.documento}/>
</div>
<fieldset>
    <legend>Documentos del servicio</legend>
    <div class="grid-2 gap-3">
        <div class="max-w-600px">
            <DocumentTable checkbox={false} data="{data.documentos.adjuntos}"/>
        </div>
        <div>
            <textarea class="naui-input w-100" rows="6" placeholder="Observaciones Internas" readonly
                      bind:value={data.documentos.observaciones}></textarea>
        </div>
    </div>
</fieldset>
{#if data.logistica}
    <fieldset>
        <legend>Logistica transporte</legend>
        {#if data.logistica.origen}
            <UbicacionTransporte bind:data={data.logistica.origen} origen="{true}"/>
            <hr>
        {/if}
        {#if data.logistica.destino}
            <UbicacionTransporte bind:data={data.logistica.destino} origen="{false}"/>
        {/if}
        <textarea bind:value="{data.logistica.observaciones}" class="naui-input w-100"
                  placeholder="Observaciones adicionales de logística y transporte"></textarea>
    </fieldset>
{/if}
{#each data.paradas as stop}
    <fieldset>
        <legend>Paradas adicionales</legend>
        <div class="grid-7-5 gap-3">
            <div>
                <div class="grid-3 gap-1 mb-1">
                    <NauiSelect options="" label="Ciudad origen"/>
                    <NauiSelect label="Tipo de inmueble" options=""/>
                    <NauiInput label="Piso"/>
                </div>
                <NauiInput label="Dirección origen"/>
            </div>
            <div>
                <UbicacionManejoVertical bind:data={stop.vertical}/>
            </div>
        </div>
    </fieldset>
{/each}

{#if data.tipoEmbalaje}
<fieldset>
    <legend>Tipo de embalaje</legend>
    <TipoEmbalaje bind:data={data.tipoEmbalaje}/>
</fieldset>
{/if}

{#if data.bodegaje}
    <fieldset>
        <legend>Bodegaje</legend>
        <div class="box-l sx-1 max-w-500px mb-15">
            <NauiSelect label="Bodega Separada" options="" bind:value={data.bodegaje.bodega}/>
            <NauiSelect label="Bodega número" options="" bind:value={data.bodegaje.bodegaNumero}/>
        </div>
        <div>
        <textarea class="naui-input w-100" placeholder="Observaciones adicionales bodegaje"
                  bind:value={data.bodegaje.observaciones}></textarea>
        </div>
    </fieldset>
{/if}
{#if data.muebles.length > 0}
    <fieldset>
        <legend>Muebles incluídos</legend>
        <table class="naui-table style-alt">
            <thead>
            <tr>
                <th class="min-w-200px">
                    <div>ITEMS</div>
                </th>
                <th class="min-w-200px">
                    <div class="box">M3</div>
                </th>
                <th class="min-w-200px">
                    <div class="box">Cantidad</div>
                </th>
            </tr>
            </thead>
            <tbody>
            {#each data.muebles as mueble (mueble.id) }
                <tr>
                    <td>
                        <div><strong>{mueble.label}</strong></div>
                    </td>
                    <td>
                        <div class="box">{mueble.m3}</div>
                    </td>
                    <td>
                        <!--div class="box"></div-->
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    </fieldset>
{/if}